import React from 'react';
import PropTypes from 'prop-types';

import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import ConnectedFormattedImage from 'Containers/ConnectedFormattedImage';
import ExploreCard from 'Components/ExploreCard';
import { ROUTES } from 'Settings/route-strings';

const ModelCard = ({ isNew, topics, slug, isDisabled, thumbnailImg }) => {
  return (
    <ExploreCard
      to={`${ROUTES.EXPLORE}/${slug}`}
      isNew={isNew}
      id={slug}
      type="model"
      isDisabled={isDisabled}
      graphic={
        <ConnectedFormattedImage
          className="ExploreCard__image"
          src={thumbnailImg}
          altId={`model.${slug}.graphicAlt`}
        />
      }
      title={<ConnectedFormattedMessage id={`model.${slug}.title`} />}
      body={
        <ul className="ExploreCard__topics">
          {topics.map((topic, i) => (
            <li className="ExploreCard__topic" key={`topic-${i}`}>
              <ConnectedFormattedMessage
                id={`model.${slug}.topics.${topic}.title`}
              />
            </li>
          ))}
        </ul>
      }
    />
  );
};

ModelCard.propTypes = {
  isNew: PropTypes.bool.isRequired,
  topics: PropTypes.array.isRequired,
  slug: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  thumbnailImg: PropTypes.string.isRequired,
};

export default ModelCard;
